/* cart-toggle.js | Forces cart icon to open drawer regardless of configuration */
(function() {
  // Check if native cart drawer is disabled
  const isNativeCartDisabled = window.Shopify && 
    window.Shopify.theme && 
    window.Shopify.theme.settings && 
    window.Shopify.theme.settings.disable_native_cart_drawer === true;
  
  if (isNativeCartDisabled) {
    console.log('[cart-toggle.js] Native cart drawer is disabled in settings. Exiting.');
    return;
  }
  
  // Wait for both DOM and web components to be ready
  function waitForCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    const btn = document.getElementById('cart-icon-bubble');
    
    if (!btn) {
      console.log('[cart-toggle.js] Cart icon not found');
      return;
    }
    
    if (!drawer) {
      console.log('[cart-toggle.js] Cart drawer not found - checking if cart_type is drawer...');
      // If no drawer, remove our interference and let default behavior work
      return;
    }
    
    console.log('[cart-toggle.js] Found cart drawer, setting up click handler');
    
    // Remove any existing href to prevent navigation
    if (btn.href) {
      btn.removeAttribute('href');
    }
    
    // Force our click handler to be first
    const clickHandler = function(e) {
      console.log('[cart-toggle.js] Click intercepted');
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle the drawer
      if (!drawer) return;
      const isActive = drawer.classList.contains('active');
      if (isActive) {
        console.log('[cart-toggle.js] Closing drawer via close() method');
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        }
      } else {
        console.log('[cart-toggle.js] Opening drawer via open() method');
        if (typeof drawer.open === 'function') {
          drawer.open(newBtn);
        } else {
          drawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
        }
      }
      
      return false;
    };
    
    // Remove existing listeners and add ours
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    
    // Add our listener
    newBtn.addEventListener('click', clickHandler, true); // Use capture
    
    console.log('[cart-toggle.js] Setup complete');
  }
  
  // Try multiple times to ensure we catch the drawer after it's initialized
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForCartDrawer);
  } else {
    waitForCartDrawer();
  }
  
  // Also try after a delay in case cart-drawer is initialized async
  setTimeout(waitForCartDrawer, 1000);
})();
